/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");
export const LOCATION_NOT_FOUND = require("./res/images/locationNotFound.png");

export const CREDENTIAL_GEO_FENCED = require("./res/images/geo.png");
export const CREDENTIAL_WEBSITE = require("./res/images/website.png");
export const CREDENTIAL_FFEDBACK = require("./res/images/feedback.png");
export const CREDENTIAL_MENU = require("./res/images/menu-white.png");

export const TRACK_LOADER_LOTTIE = require("./res/lotties/track.json");

export const LOADING_IMAGE = require("./res/images/loading-img.png");
export const NO_IMAGE = require("./res/images/no-image.png");

export const TRAG_LIGHT_LOGO = require("./res/images/trag-2.png");
export const PRODUCT_JOURNEY = require("./res/images/product_journey.png");
export const PROTECT_B_AND_C = require("./res/images/Protect_brand_and_customer.png");
export const TRAG_ILLUSTRATION = require("./res/images/trag-illustration.png");
export const TRAG_LOGO = require("./res/images/trag.png");
export const TRANSPARENCY = require("./res/images/Transparency.png");
export const BANNER_IMAGE = require("./res/images/bg.png");
export const AUTHENTICITY = require("./res/images/Authenticity.png");
export const EFFICIENCY = require("./res/images/Efficiency.png");
export const CUSTOMER_ENGAGEMENT = require("./res/images/Customer_Engagement.png");
export const ELEVATE_CE = require("./res/images/Elevate_customer_experience.png");
export const VIDEO = require("./res/images/default-video.png");
export const THUMB_NAIL = require("./res/images/Godawan_thumb.jpg");
export const TEXTBOX = require("./res/images/textBox.png");
export const PROV_CARD_BG_WALLPAPER = require("./res/images/cert.png");

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    LOCATION_NOT_FOUND,
    LOADING_IMAGE,
    NO_IMAGE,
    TRAG_LIGHT_LOGO,
    PRODUCT_JOURNEY,
    PROTECT_B_AND_C,
    TRAG_ILLUSTRATION,
    TRAG_LOGO,
    TRANSPARENCY,
    BANNER_IMAGE,
    AUTHENTICITY,
    EFFICIENCY,
    CUSTOMER_ENGAGEMENT,
    ELEVATE_CE,
    VIDEO,
    THUMB_NAIL,
    TEXTBOX,
    PROV_CARD_BG_WALLPAPER
];
